module.exports = __webpack_public_path__ + "media/how_to_buy.335e0fcc.mp4";